import { SavedFilterItem } from '@/lib/saved-filters';
import { UserEventAction } from '@/lib/models/user-event';
import { ReferrerRelation } from '@/lib/models/user-event/helpers';

export const predefinedSavedFilters: SavedFilterItem[] = [
  {
    id: 'predefined-intercepted',
    name: 'Intercepted Requests',
    isPreset: true,
    values: [
      {
        columnName: 'action',
        // The user-events page rewrites filter values via `addLikeActionFilterValue`
        // (ALLOW → [ALLOW, REROUTE]). The preset must be pre-expanded so the live
        // filter equals the saved snapshot — otherwise auto-detect stops matching
        // after the rewrite.
        value: [
          String(UserEventAction.ALLOW),
          String(UserEventAction.REROUTE),
          String(UserEventAction.REDACT),
        ],
      },
    ],
  },
  {
    id: 'predefined-blocked',
    name: 'Blocked Requests',
    isPreset: true,
    values: [
      {
        columnName: 'action',
        value: [String(UserEventAction.BLOCK), String(UserEventAction.INLINEBLOCK)],
      },
    ],
  },
  {
    id: 'predefined-risky',
    name: 'High Risk Requests',
    isPreset: true,
    values: [
      {
        columnName: 'riskLevel',
        value: ['high', 'critical'],
      },
    ],
  },
  {
    id: 'predefined-violations',
    name: 'Any Violation',
    isPreset: true,
    values: [
      {
        columnName: 'violation',
        value: [
          'pii',
          'access',
          'intent',
          'confidentialData',
          'promptInjection',
          'toxicity',
          'code',
          'bias',
          'risk',
          'tool',
          'training',
          'license',
          'fileUpload',
        ],
      },
    ],
  },
  {
    id: 'predefined-mcp',
    name: 'MCP Violations',
    isPreset: true,
    values: [
      {
        columnName: 'violation',
        value: ['tool'],
      },
    ],
  },
  {
    id: 'predefined-aligned-referrers',
    name: 'Aligned Referrers',
    isPreset: true,
    values: [
      {
        columnName: 'referrerRelation',
        value: ReferrerRelation.ALIGNED,
      },
    ],
  },
  {
    id: 'predefined-mismatched-referrers',
    name: 'Misaligned Referrers',
    isPreset: true,
    values: [
      {
        columnName: 'referrerRelation',
        value: ReferrerRelation.MISMATCHED,
      },
    ],
  },
];
